import Box from '@material-ui/core/Box';
import { ROLES } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { hasRestrictedRole, hasValue } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { columns, formattedType } from './config';
import { checkServiceProvider } from './serviceProviderConfig';
import TopActions from './TopActions';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Link = lazy(() => import(`globalcomponents/UI/Link`));

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle, overflowX: 'hidden' }}>
      <WorkOrderComponent {...contentProps} filters={filters} />
    </Box>
  );
};
export default Index;

const WorkOrderComponent = ({
  apiStatus,
  callback,
  history,
  Styled,
  fetchInspections,
  bulkDownloadReport,
  inspections,
  list,
  changeRequest,
  isAdvancedDviRequired,
  isCustomDviRequired,
  clearApiStatus,
  i18n,
  topAction,
  filters,
  viewReport,
  request,
  pagination,
  setPagination,
  needSort,
}) => {
  const hasApiStatus = hasValue(apiStatus.status, 'api', fetchInspections);
  const information =
    hasApiStatus && hasApiStatus.errorMessage ? (
      <Message type="error" s message={i18n.t(hasApiStatus.errorMessage)} />
    ) : (
      i18n.t('common.tableEmptyMessage')
    );

  const generateRows = () => {
    return (
      inspections?.content?.map((item) => {
        const isServiceManager = hasRestrictedRole([ROLES.SERVICE_MANAGER]);
        const vinTrimmedValue = item?.unit_id?.name ? `...${item.unit_id.name.slice(-8)}` : '-';

        return {
          ...item,
          id: item.work_order_id,
          type: formattedType[item.type] || '-',
          work_order_id: <Link href={`/inspections/edit/${item.work_order_id}`}>{item.work_order_id}</Link>,
          unitId: isServiceManager ? (
            vinTrimmedValue
          ) : (
            <Link href={`/${item.unitType === 'TRAILER' ? 'trailer' : 'vehicle'}/edit/${item.unit_id?.id}`}>{vinTrimmedValue}</Link>
          ),
          driverName: isServiceManager ? item.driverName : <Link href={`/user/edit/${item.driver?.id}`}>{item.driverName}</Link>,
          report: item.inspection_report?.id ? (
            <Icon
              src={mediaUrls?.viewReports}
              tableicon
              onClick={() =>
                viewReport({
                  apiId: 'viewReportApi',
                  data: item.inspection_report.id,
                })
              }
              tooltip={i18n.t('workOrders.viewReport')}
            />
          ) : (
            <div className="noPointer">
              <Icon src={mediaUrls?.viewReports} tableicon />
            </div>
          ),
        };
      }) || []
    );
  };

  return (
    <Styled.Wrapper>
      {topAction && (
        <TopActions
          {...{
            isAdvancedDviRequired,
            isCustomDviRequired,
            i18n,
            history,
            list,
            bulkDownloadReport,
            apiStatus,
            clearApiStatus,
            callback,
            Styled,
            changeRequest,
            hasApiStatus,
            filters,
            request,
            pagination,
            setPagination,
          }}
        />
      )}
      <div className="quickFilter"></div>
      <Styled.TableWrapper>
        <div className="driverstatusTitle">
          <span className="spireonOldOnly">Inspections</span>
        </div>
        <Table
          type="server"
          defaultSortBy={needSort ? { sortBy: 'type', order: 'desc' } : null}
          changeRequest={changeRequest}
          baseRequest={request}
          title=""
          columns={[...columns]}
          data={generateRows()}
          emptyMessage={information}
          itemsPerPage={checkServiceProvider('component_itemsPerPage', window.$environment.SERVICE_PROVIDER, false)}
          totalRecords={inspections?.totalElements}
          actions={[]}
          i18n={i18n}
          pageinationReset={pagination}
          pagenationClicked={(e) => {
            setPagination(!e);
          }}
        />
      </Styled.TableWrapper>
    </Styled.Wrapper>
  );
};

WorkOrderComponent.propTypes = {
  history: PropTypes.object.isRequired,
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  fetchViolations: PropTypes.func.isRequired,
  handleExportCsaViolations: PropTypes.func.isRequired,
};
